module.exports = __webpack_public_path__ + "img/gift-ui-01.3f610328.png";